module.exports = __webpack_public_path__ + "static/media/Vector.3c00e1b7.svg";